// extracted by mini-css-extract-plugin
export default {"wrapper":"OverviewChartCard_wrapper__9ZSjt","additionalText":"OverviewChartCard_additionalText__fXkH9","chartControls":"OverviewChartCard_chartControls__5+KvI"};